import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * iter-85 · Ensures every route change starts the new page at the very top.
 *
 * Historically, React Router preserves the previous page's scroll position
 * on navigation. Visitors browsing the Beach Club calendar and clicking an
 * offer arrived on the offer detail scrolled halfway down, which felt
 * broken. This component listens to pathname/search changes and resets
 * window scroll instantly, without a smooth animation (which can be
 * interrupted by concurrent step animations).
 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (typeof window === "undefined") return;
    // Use instant (no smooth) so the reset is guaranteed even when a page
    // transition animation is running. Fallbacks cover older browsers.
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }, [pathname, search]);
  return null;
}
